var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCountryParam } from "@/hooks/useCountryParam";
import { getJobCategorySuids } from "@/jobCategorySuids";
import { getJobTypeSuids } from "@/jobTypeSuids";
import { SearchParamType } from "@/types/SearchParamType";
import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getUpdatedSearchParams } from "@/components/utils";
import Util from "../../util/Util";
import { SearchFormContext } from "./SearchFormContext";
function SearchForm(_a) {
    var children = _a.children;
    var _b = useSearchParams(), searchParams = _b[0], setSearchParams = _b[1];
    var countryParam = useCountryParam();
    var _c = useState(Util.normalize(searchParams.get(SearchParamType.WHAT) || "")), queryValue = _c[0], setQueryValue = _c[1];
    var _d = useState(Util.normalize(searchParams.get(SearchParamType.WHERE) || "")), locationValue = _d[0], setLocationValue = _d[1];
    var _e = useState(Util.normalize(countryParam)), countryValue = _e[0], setCountryValue = _e[1];
    var _f = useState(Util.normalizeBool(searchParams.get(SearchParamType.IS_REMOTE_ONLY) || "")), isRemoteOnlyValue = _f[0], setIsRemoteOnlyValue = _f[1];
    var _g = useState(Util.normalize(searchParams.get(SearchParamType.COMPANY) || "")), companyValue = _g[0], setCompanyValue = _g[1];
    var _h = useState(function () {
        return getJobCategorySuids(searchParams);
    }), jobCategorySuidValues = _h[0], setJobCategorySuidValues = _h[1];
    var _j = useState(function () {
        return getJobTypeSuids(searchParams);
    }), jobTypeSuidValues = _j[0], setJobTypeSuidValues = _j[1];
    useEffect(function () {
        setJobCategorySuidValues(getJobCategorySuids(searchParams));
        setJobTypeSuidValues(getJobTypeSuids(searchParams));
    }, [searchParams]);
    var handleSubmit = function (e) {
        e.preventDefault();
        onSearchFormSubmit(queryValue, locationValue, countryValue, isRemoteOnlyValue, companyValue, jobCategorySuidValues, jobTypeSuidValues);
    };
    var value = useMemo(function () { return ({
        queryParamKey: SearchParamType.WHAT,
        queryValue: queryValue,
        setQueryValue: setQueryValue,
        locationParamKey: SearchParamType.WHERE,
        locationValue: locationValue,
        setLocationValue: setLocationValue,
        isRemoteOnlyParamKey: SearchParamType.IS_REMOTE_ONLY,
        isRemoteOnlyValue: isRemoteOnlyValue,
        setIsRemoteOnlyValue: setIsRemoteOnlyValue,
        countryParamKey: SearchParamType.COUNTRY,
        countryValue: countryValue,
        setCountryValue: setCountryValue,
        companyParamKey: SearchParamType.COMPANY,
        companyValue: companyValue,
        setCompanyValue: setCompanyValue,
        jobCategorySuidParamKey: SearchParamType.JOB_CATEGORY_SUID,
        jobCategorySuidValues: jobCategorySuidValues,
        setJobCategorySuidValues: setJobCategorySuidValues,
        jobTypeSuidParamKey: SearchParamType.JOB_TYPE_SUID,
        jobTypeSuidValues: jobTypeSuidValues,
        setJobTypeSuidValues: setJobTypeSuidValues,
    }); }, [
        locationValue,
        queryValue,
        isRemoteOnlyValue,
        countryValue,
        companyValue,
        jobCategorySuidValues,
        jobTypeSuidValues,
    ]);
    var onSearchFormSubmit = function (queryValue, locationValue, countryValue, isRemoteOnlyValue, companyValue, jobCategorySuidValues, jobTypeSuidValues) {
        if (queryValue === void 0) { queryValue = undefined; }
        if (locationValue === void 0) { locationValue = undefined; }
        if (countryValue === void 0) { countryValue = undefined; }
        if (isRemoteOnlyValue === void 0) { isRemoteOnlyValue = undefined; }
        if (companyValue === void 0) { companyValue = undefined; }
        if (jobCategorySuidValues === void 0) { jobCategorySuidValues = undefined; }
        if (jobTypeSuidValues === void 0) { jobTypeSuidValues = undefined; }
        var updatedParams = getUpdatedSearchParams(searchParams, queryValue, locationValue, isRemoteOnlyValue, undefined, countryValue, companyValue, jobCategorySuidValues, jobTypeSuidValues);
        setSearchParams(updatedParams);
    };
    return (_jsx(SearchFormContext.Provider, __assign({ value: value }, { children: _jsx("form", __assign({ onSubmit: handleSubmit }, { children: children })) })));
}
export { SearchForm };
